import React from "react";

const ButtonLoader = (params: { className?: string }) => {
  return (
    <span
      className={`loading loading-spinner loading-xs ${params.className || ""}`}
    ></span>
  );
};

export default ButtonLoader;
